import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Majuscule sur la première lettre seulement.
 * À préférer aux classes CSS : `capitalize` majusculerait chaque mot
 * (« Ce Jeudi »), et `first-letter:` ne s'applique pas aux éléments inline.
 */
export const capFirst = (v: string) => (v ? v[0].toUpperCase() + v.slice(1) : v);
